import React, { useContext, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";

import './Navbar.css'
import './../Theme/Theme.css'
import { Icons } from '../../lib/icons';
import ThemeContext from '../../contexts/ThemeContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography';

interface NavbarProps {
  loggedIn: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ loggedIn }) => {
  const navbarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let prevScrollPos = window.scrollY;
    let downLength = 0;

    window.addEventListener('scroll', () => {
      const currentScrollPos = window.scrollY;
      if (prevScrollPos > currentScrollPos) {
        navbarRef.current!.classList.remove('navbar-hide');
        downLength = 0;
      } else if (currentScrollPos > navbarRef.current!.offsetHeight) {
        if (downLength > navbarRef.current!.offsetHeight / 2) {
          navbarRef.current!.classList.add('navbar-hide');
        }
        downLength += currentScrollPos - prevScrollPos;
      }
      prevScrollPos = currentScrollPos;
    });
  }, [navbarRef]);


  const { theme } = useContext(ThemeContext);
  return (
    <Box className='navbar' ref={navbarRef}>
      <Box className='navbar-section' id='navbar-left'>
        <Link to='/' className='navbar-link-container'>
          <LazyLoadImage src={theme === 'dark' ? Icons.LOGO_LIGHT : Icons.LOGO_DARK} alt='logo' id='navbar-logo' />
        </Link>
      </Box>
      <Box className='admin-section'>
        <Link to='/login' className='navbar-link-container'>
          <p className='navbar-link'>Admin</p>
        </Link>
      </Box>
      <Box className='navbar-section' id='navbar-center'></Box>
      <Box className='navbar-section' id='navbar-right'>
        <Link to='/about' className='navbar-link-container'>
          <Typography
            className="navbar-link"
            component="p"
            sx={{ fontSize: { xs: '10px', sm: '12px', md: '16px', lg: '18px' } }}
          >
            About
          </Typography>
        </Link>
        <Link to='/services' className='navbar-link-container'>
          <Typography
            className="navbar-link"
            component="p"
            sx={{ fontSize: { xs: '10px', sm: '12px', md: '16px', lg: '18px' } }}
          >
            Services
          </Typography>
        </Link>
        <Link to='/news' className='navbar-link-container'>
          <Typography
            className="navbar-link"
            component="p"
            sx={{ fontSize: { xs: '10px', sm: '12px', md: '16px', lg: '18px' } }}
          >
            News
          </Typography>
        </Link>
        <Link to='/contact' className='navbar-link-container'>
          <Typography
            className="navbar-link"
            component="p"
            sx={{ fontSize: { xs: '10px', sm: '12px', md: '16px', lg: '18px' } }}
          >
            Contact
          </Typography>
        </Link>
        <Link to='https://www.billetportal.ca' className='navbar-link-container'>
          <Typography
            className="navbar-link"
            component="p"
            sx={{ fontSize: { xs: '10px', sm: '12px', md: '16px', lg: '18px' } }}
          >
            Login
          </Typography>
        </Link>
      </Box>

    </Box>
  );
};

export default Navbar;
